import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import MyFloatingLabelInput from '../form/MyFloatingLabelInput';
import Colors from '../../constants/Colors';
import Svg from '../Svg';

const styles = StyleSheet.create({
  passwordContainer: {
    width: '100%',
  },
  testContainer: {
    marginTop: 15,
  },
  singleTest: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginBottom: 9,
  },
  text: {
    fontFamily: 'roboto-bold',
    fontSize: 13,
    fontWeight: '900',
    color: Colors.veryDarkGray,
    marginLeft: 8,
  },
  error: {
    color: Colors.brightRed,
  },
  eyeIcon: {
    marginLeft: -22,
  },
  underline: {
    display: 'flex',
    flexDirection: 'row',
  },
});

class PasswordField extends Component {
  static propTypes = {
    translation: PropTypes.objectOf(PropTypes.any).isRequired,
    onTextChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    createPassword: PropTypes.bool.isRequired,
    error: PropTypes.bool,
  };

  constructor(props) {
    super();
    this.state = {
      password: '',
      testCharacters: false,
      testSpecials: false,
      testNumbers: false,
      showPassword: false,
    };
  }

  onUpdateText = (value) => {
    const { onTextChange } = this.props;
    const trimmed = value.trim();
    const testCharacters = trimmed && trimmed.length > 7;
    const testSpecials = /\W|_/g.test(trimmed);
    const testNumbers = /\d/.test(trimmed);
    this.setState({
      password: trimmed,
      testCharacters,
      testSpecials,
      testNumbers,
    });
    onTextChange({
      isValid: testCharacters && testSpecials && testNumbers,
      password: trimmed,
    });
  };

  swapVisibility = () => {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  };

  onBlur = () => {
    const { onBlur } = this.props;
    if (onBlur) onBlur();
  };

  onFocus = () => {
    const { onFocus } = this.props;
    if (onFocus) onFocus();
  };

  render() {
    const { translation, createPassword, error } = this.props;
    const { password, showPassword, testCharacters, testNumbers, testSpecials } = this.state;

    return (
      <View style={styles.passwordContainer}>
        <View error={error} style={styles.underline}>
          <MyFloatingLabelInput
            label={translation.password}
            value={password}
            onChangeText={this.onUpdateText}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            isPassword
            togglePassword={showPassword}
            testID="password"
            width={328}
            error={error ? translation.password_error : ''}
          />
          <TouchableOpacity onPress={this.swapVisibility} style={styles.eyeIcon}>
            <Svg icon={showPassword ? 'eye_stripethrough' : 'eye'} />
          </TouchableOpacity>
        </View>
        {createPassword ? (
          <View style={styles.testContainer}>
            <View style={styles.singleTest}>
              {testCharacters ? <Svg icon="checked" width={14} /> : <Svg icon="unchecked" width={14} />}
              <Text style={styles.text}>{translation.eight_characters}</Text>
            </View>
            <View style={styles.singleTest}>
              {testSpecials ? <Svg icon="checked" width={14} /> : <Svg icon="unchecked" width={14} />}
              <Text style={styles.text}>{translation.one_special_character}</Text>
            </View>
            <View style={styles.singleTest}>
              {testNumbers ? <Svg icon="checked" width={14} /> : <Svg icon="unchecked" width={14} />}
              <Text style={styles.text}>{translation.one_number}</Text>
            </View>
          </View>
        ) : null}
      </View>
    );
  }
}

export default PasswordField;
